export default __webpack_public_path__ + "static/media/mensagem.9d2f8563.svg";